import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class ReportsApi {
  static getAllReports(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.reports, { params });
  }

  static getReport({ id, params }) {
    return axios.get(ApiEndpoints.report.replace(':id:', id), { params });
  }
}

export default ReportsApi;
